export enum CallStatus {
    RING = "Звонок",
    ANSWERED = "Ответ",
    NO_ANSWERED = "Нет ответа",
    FAILED = "Ошибка",
    BUSY = "Занят"
}
